<div class="neq-dialog neq-advanced-search" fxLayout="column" style="width: 40vw">
  <h1>{{ 'label.user.advanced-search.references.title' | translate }}</h1>

  <div [formGroup]="form" fxLayout="column" fxLayoutGap="0.357rem">
    <div class="tree-select-container" fxLayout="row" *ngIf="levels; else loading">
      <p-treeSelect
        [options]="levels"
        [placeholder]="'label.common.level' | translate"
        [filter]="true"
        [showClear]="true"
        selectionMode="single"
        [emptyMessage]="'msg.common.levels.empty' | translate"
        formControlName="level"
        appendTo="body">
      </p-treeSelect>
    </div>
    <ng-template #loading>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
          <p-progressSpinner styleClass="inline-spinner" animationDuration=".5s"
          ></p-progressSpinner>
          {{'msg.common.levels.loading' | translate}}
        </div>
      </div>
    </ng-template>

    <div fxLayout="row" fxLayoutAlign="start center">
      <neq-select-autocomplete [dataSource]="predictionModelsDatasource" appendTo=".neq-advanced-search"
                               [defaultLabel]="'label.common.prediction-models' | translate"
                               bindLabel="label" formControlName="predictionModel"
                               #predictionModelSelectAutocomplete fxFlex="75"></neq-select-autocomplete>
      <div>{{ predictionModelsNumber }} {{ 'label.common.prediction-models' | translate }}</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <neq-select-autocomplete [dataSource]="referencesDatasource" appendTo=".neq-advanced-search"
                               [defaultLabel]="'label.common.references' | translate"
                               bindLabel="label" formControlName="reference"
                               #referenceSelectAutocomplete fxFlex="75"></neq-select-autocomplete>
      <div>{{ referencesNumber }} {{ 'label.common.references' | translate }}</div>
    </div>

    <div class="asi-container" fxLayout="row" fxLayoutAlign="end center">
      <button pButton class="neq-primeng-button-text" label="{{ 'label.common.edition.cancel' | translate }}" (click)="onCancel()"></button>
      <button pButton class="neq-primeng-button-text" label="{{ 'label.common.edition.confirm' | translate }}" [disabled]="isSubmitDisabled" (click)="onFormSubmit()"> </button>
    </div>
  </div>
</div>
